import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function RequoteInfoPage() {
    const { requoteId } = useParams();
    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchRequote() {
            try {
                const res = await axios.get(`/api/manage/requotes/${requoteId}`);
                setInfo(res.data);
            } catch (err) {
                console.error("견적서 정보를 불러오지 못했습니다.", err);
            } finally {
                setLoading(false);
            }
        }
        fetchRequote();

        setLoading(false);
    }, [requoteId]);

    if (loading) {
        return <div style={{ textAlign: "center", marginTop: 60 }}>로딩 중...</div>;
    }
    if (!info) {
        return <div style={{ textAlign: "center", marginTop: 60, color: "#ff4d4f" }}>견적서 정보를 불러올 수 없습니다.</div>;
    }

    return (
        <div style={{ maxWidth: 600, margin: "40px auto", fontFamily: "sans-serif" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>견적서 상세정보</h2>
            <table style={{ width: "100%", borderCollapse: "collapse", background: "#fafbfc", borderRadius: 8, overflow: "hidden", marginBottom: 32 }}>
                <tbody>
                    <tr>
                        <th style={thStyle}>견적 요청 ID</th>
                        <td style={tdStyle}>{info.quoteId}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>회사명</th>
                        <td style={tdStyle}>{info.member.companyName}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>평점</th>
                        <td style={tdStyle}>{info.member.rating}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>견적 상세</th>
                        <td style={tdStyle}>{info.detail}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>제출일</th>
                        <td style={tdStyle}>{new Date(info.createdAt).toLocaleDateString()}</td>
                    </tr>
                </tbody>
            </table>
            <h3 style={{ marginBottom: 12 }}>견적 내역</h3>
            <table style={{ width: "100%", borderCollapse: "collapse", background: "#fff", borderRadius: 8 }}>
                <thead>
                    <tr style={{ background: "#f5f6fa" }}>
                        <th style={thStyle}>항목</th>
                        <th style={thStyle}>금액</th>
                    </tr>
                </thead>
                <tbody>
                    {info.etc.map((item, idx) => (
                        <tr key={idx}>
                            <td style={tdStyle}>{item.name}</td>
                            <td style={tdStyle}>{item.price.toLocaleString()}원</td>
                        </tr>
                    ))}
                    <tr>
                        <td style={tdStyle}>유지비</td>
                        <td style={tdStyle}>{info.maintain.toLocaleString()}원</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>세금</td>
                        <td style={tdStyle}>{info.tax.toLocaleString()}원</td>
                    </tr>
                    <tr>
                        <td style={{ ...tdStyle, fontWeight: 600 }}>합계</td>
                        <td style={{ ...tdStyle, fontWeight: 600 }}>{info.sum.toLocaleString()}원</td>
                    </tr>
                </tbody>
            </table>
            <button
                style={{
                    background: "#ff4d4f",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: "12px 40px",
                    fontWeight: 600,
                    fontSize: 16,
                    cursor: "pointer",
                    marginTop: 24
                }}
                onClick={() => {
                    if (window.confirm(`정말로 이 견적서를 삭제하시겠습니까?`)) {
                        axios.delete(`/api/manage/requotes/${requoteId}`)
                            .then(() => window.location.href = "/quote/" + info.quoteId)
                            .catch(err => alert("삭제 실패: " + err.message));
                        alert("삭제되었습니다.");
                    }
                }}
            >
            견적서 삭제
            </button>
        </div>
    );
}

const thStyle = {
    background: "#f5f6fa",
    textAlign: "left",
    padding: "10px 8px",
    fontWeight: 600,
    borderBottom: "1px solid #e1e1e1"
};

const tdStyle = {
    padding: "10px 8px",
    borderBottom: "1px solid #f0f0f0",
    whiteSpace: "pre-wrap",
};